// src/pages/BlogDetail.jsx
import React, { useEffect, useState } from "react";
import { fetchBlogBySlug } from "../services/BlogService";
import { useParams } from "react-router-dom";
import { motion } from "framer-motion";
import "./Blog.css";

export default function BlogDetail() {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const b = await fetchBlogBySlug(slug);
        setBlog(b);
      } catch (e) {
        console.error(e);
      }
    })();
  }, [slug]);

  if (!blog) return <div className="p-4">Loading…</div>;

  return (
    <div className="blog-detail">
      <div className="blog-hero small">
        <motion.h1 initial={{opacity:0,y:6}} animate={{opacity:1,y:0}}>{blog.title}</motion.h1>
        <p className="lead text-muted">{blog.excerpt}</p>
      </div>

      <div className="container py-4">
        <div className="card p-4">
          {blog.mediaUrl && (/\.(mp4|webm|ogg)$/i.test(blog.mediaUrl) ? (
            <video src={blog.mediaUrl} className="w-100 mb-3" controls />
          ) : (
            <img src={blog.mediaUrl} className="w-100 mb-3" alt={blog.title} />
          ))}

          <div className="blog-content" dangerouslySetInnerHTML={{ __html: blog.content }} />
        </div>
      </div>
    </div>
  );
}
